import SharedResource from '@/mixins/shared-resource'
import Draggable from 'vuedraggable'

export default {
  mixins: [SharedResource],
  components: {
    'v-draggable': Draggable,
  },
  data() {
    return {
      valid: false,
      tab: null,
      loading: {
        fetching: false,
        updating: false,
        cancelling: false,
        updatingAlt: false,
      },
      rules: {},
      formData: {},
    }
  },
  computed: {
    disabled() {
      return Object.keys(this.loading).some(loading => this.loading[loading] === true)
    },
  },
  async mounted() {
    await this.setResourceToFormData()
  },
  methods: {
    async cancelUpdatingResource() {
      this.loading.cancelling = true
      this.$router.push(this.redirectToView(this.$route.params.id))
    },
    async updateResourceWithoutRedirect() {
      this.loading.updatingAlt = true
      if (!this.$refs.form.validate()) return (this.loading.updatingAlt = false)
      await this.updateResource()
        .then(() => {
          this.loading.updatingAlt = false
          this.$refs.form.resetValidation()
          this.setResourceToFormData(this.resource)
        })
        .catch(() => {
          this.loading.updatingAlt = false
        })
    },
    async updateResourceWithRedirect() {
      this.loading.updating = true
      if (!this.$refs.form.validate()) return (this.loading.updating = false)
      await this.updateResource()
        .then(() => {
          this.loading.updating = false
          this.$refs.form.resetValidation()
          this.setResourceToFormData(this.resource)
          this.$router.push(this.redirectToView(this.$route.params.id))
        })
        .catch(() => {
          this.loading.updating = false
        })
    },
    async setResourceToFormData(formData = null) {
      this.loading.fetching = true
      if (!formData) {
        await this.findResource(this.$route.params.id).catch(err => {
          this.$router.push(this.redirectToIndexView())
          this.$notify({ type: 'error', text: 'Unable to retrieve resource' })
        })
      }
      this.formData = formData === null ? this.resource : formData
      if (typeof this.postRequestedData === 'function') await this.postRequestedData()
      this.loading.fetching = false
    },
  },
}
